import * as React from 'react';
import Form from 'src/components/controls/forms/Form';
import IOwner from 'src/models/IOwner';
import AddressUtil from 'src/util/Address';
import FormCheckbox from 'src/components/controls/forms/redesign/FormCheckbox';
import { FieldArray } from 'react-final-form-arrays';
import FormRow from 'src/components/controls/forms/FormRow';
import * as _ from 'lodash';
import { FormApi } from 'final-form';
import SearchResult from 'src/models/OwnerSearchResult';
import { AnyObject } from 'react-final-form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { ManageDeviationsPage } from './ManageDeviationsDialog';
import OwnerUtil from 'src/util/OwnerUtil';

export interface ISeparateDeviationDialogProps {
    separateDeviationsFormCreated: (form: FormApi) => void;
    separateDeviation: (owner: IOwner) => void;
    clearTargetDeviations: () => void;
    changePage: (page: ManageDeviationsPage) => void;
}

export type ISeparateDeviationStateProps = {
    ownerDeviations: Array<IOwner>;
    searchResults?: Array<SearchResult>;
    form: FormApi;
    page: ManageDeviationsPage;
};

type ISeparateDeviationState = {
    hasUncheckedDeviations: boolean;
    searchString: string;
    searchOwnerType: string;
};

type ISeparateDeviationDialogPageProps = ISeparateDeviationDialogProps & ISeparateDeviationStateProps;

class SeparateDeviation extends React.Component<ISeparateDeviationDialogPageProps, ISeparateDeviationState> {
    constructor(props: ISeparateDeviationDialogPageProps) {
        super(props);
        this.state = {
            hasUncheckedDeviations: false,
            searchString: undefined,
            searchOwnerType: undefined,
        };
    }

    ownerName = (owner: IOwner) => {
        let name = undefined;
        if (owner) {
            const mappedOwner = OwnerUtil.MapOwner(owner);
            name = mappedOwner ? mappedOwner.ownerName() : 'N/A';
        }
        return name;
    };

    submitPrimary = (values: AnyObject) => {
        const ownerDeviations = values.ownerDetails as IOwner[];
        const deviationToSeparate = ownerDeviations.find((x: AnyObject) => x.isSelected);
        console.log(deviationToSeparate);
        this.props.separateDeviation(deviationToSeparate);
        this.props.changePage(ManageDeviationsPage.Menu);
    };

    selectPrimarySecondaryDeviationOwner = (index: number) => {
        const valuesClone = _.cloneDeep(this.props.form?.getState().values as AnyObject);
        if (!valuesClone?.ownerDetails) {
            return;
        }
        const owners = valuesClone.ownerDetails;
        for (let i = 0; i < owners.length; ++i) {
            const tempOwner = owners[i];
            if (tempOwner === undefined) {
                continue;
            }
            if (i !== index) {
                tempOwner.isSelected = false;
            }
            this.props.form?.mutators.update('ownerDetails', i, tempOwner);
        }
        this.setState(this.state);
    };

    ownerPrimarySecondaryDeviations = () => {
        return (
            <>
                <FieldArray name="ownerDetails">
                    {({ fields, meta }) =>
                        fields.map((name, index) => (
                            <div key={name}>
                                <div>
                                    <FormRow>
                                        <div style={{ width: '1rem' }}>
                                            <FormCheckbox
                                                label=""
                                                name={`${name}.isSelected`}
                                                onChange={() => this.selectPrimarySecondaryDeviationOwner(index)}
                                            />
                                        </div>
                                        <div>
                                            <FormRow>
                                                <div className="change-owner-detail-card-name">
                                                    <label>
                                                        <span>{this.ownerName(this.props.ownerDeviations[index])}</span>
                                                    </label>
                                                </div>
                                            </FormRow>
                                            <FormRow>
                                                <div className="change-owner-detail-card-address">
                                                    {' '}
                                                    {this.props.ownerDeviations[index].address?.addressLine1}{' '}
                                                </div>
                                                <div className="change-owner-detail-card-address">
                                                    {/* tslint:disable-next-line:max-line-length */}
                                                    {AddressUtil.concatWithCommas(
                                                        this.props.ownerDeviations[index].address?.city,
                                                        this.props.ownerDeviations[index].address?.state?.name,
                                                        this.props.ownerDeviations[index].address?.zipCode
                                                    )}
                                                </div>
                                            </FormRow>
                                        </div>
                                    </FormRow>
                                </div>
                            </div>
                        ))
                    }
                </FieldArray>
            </>
        );
    };
    prevPage = () => {
        this.props.changePage(ManageDeviationsPage.Menu);
        this.props.clearTargetDeviations();
    };

    isSubmitDisabled = () => {
        const values = this.props.form.getState().values as AnyObject;
        if (values) {
            if (!values.ownerDetails.some((x: AnyObject) => _.get(x, 'isSelected') === true) || this.props.ownerDeviations?.length < 2) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    };

    public render() {
        this.props.ownerDeviations?.forEach((x: AnyObject) => (x.isSelected === undefined ? (x.isSelected = false) : (x = x)));

        return (
            <Form
                onSubmit={this.submitPrimary}
                initialValues={{ ownerDetails: this.props.ownerDeviations ? this.props.ownerDeviations : [] }}
                hasFieldArray={true}
                showDebugValues={true}
                onFormCreated={this.props.separateDeviationsFormCreated}
            >
                <div>
                    {this.props.page === ManageDeviationsPage.SeparateDeviation && (
                        <div style={{ width: '100rem' }}>
                            <div style={{ overflow: 'auto', height: '40rem' }}>{this.ownerPrimarySecondaryDeviations()}</div>
                            <div className="mt-3">
                                <Button text="Prev" onClick={() => this.prevPage()} />
                                <Button className="ml-1" type="submit" text="Separate" intent="primary" disabled={this.isSubmitDisabled()} />
                            </div>
                        </div>
                    )}
                </div>
            </Form>
        );
    }
}

export default SeparateDeviation;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/SeparateDeviations.tsx